// Better always use a two digit format in your dates obj
function get2DigitFmt(val) {
    return ('0' + val).slice(-2);
}

export function getClass(value) {
// Here you could put any logic you want. Ifs, add the value to a string, whatever...
    return value === 4 ? 'redClass' : 'blueClass';
}

// Adjust month depending on the month's day
export function getMonth(currentMonth, dayClass) {
    return currentMonth + (dayClass.includes('prevMonthDay') ? 0 : (1 + Number(dayClass.includes('nextMonthDay'))));
}

export function getDateKey(year, month, day) {
    return year + get2DigitFmt(month) + get2DigitFmt(day);
}
